import React  from 'react';
import UsersComponentProto from './users-proto/users-proto';

export default function renderDateInEdit(id, props) {
    return <UsersComponentProto renderMode="edit" id={id} {...props} />;
}